import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Session lives in a secure HttpOnly cookie set by the backend; the browser
// sends it automatically. withCredentials ensures it travels with every call.
const api = axios.create({ baseURL: API, withCredentials: true });

export default api;

// Safely extract a human-readable string from any Axios error.
// FastAPI 422 returns `detail` as an array of objects ({loc, msg, type}),
// which crashes React (Error #31) if rendered directly. Always return a string.
export const getApiError = (err, fallback = "Si è verificato un errore") => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const msg = detail.map((d) => (typeof d === "string" ? d : d?.msg)).filter(Boolean).join(". ");
    return msg || fallback;
  }
  if (detail && typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
  return fallback;
};
